import type { ReactElement } from 'react';
import React from 'react';

type Props = { className?: string };

// TODO: Import this icon from HDS when it's added there
const IconGames = ({ className = '' }: Props): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52.65 33.41"
    className={className}
  >
    <path d="M52,21.7,47.18,9.18A14.37,14.37,0,0,0,33.8,0H18.86A14.37,14.37,0,0,0,5.47,9.18L.64,21.7a8.48,8.48,0,0,0,4.6,11.06,8.47,8.47,0,0,0,9.08-1.67c.12-.12,1.89-1.73,4.86-4.44A7.11,7.11,0,0,1,24,24.78h4.65a7.11,7.11,0,0,1,4.82,1.87l4.86,4.44A8.49,8.49,0,0,0,52,21.7ZM45.9,29.12a4.55,4.55,0,0,1-4.87-.9l-4.9-4.48a11.06,11.06,0,0,0-7.48-2.9H24a11.08,11.08,0,0,0-7.48,2.9l-4.9,4.48a4.56,4.56,0,0,1-4.87.9,4.5,4.5,0,0,1-2.46-2.46,4.56,4.56,0,0,1,0-3.48L9.14,10.6a10.45,10.45,0,0,1,9.72-6.66H33.8a10.45,10.45,0,0,1,9.71,6.66l4.83,12.54,0,0A4.55,4.55,0,0,1,45.9,29.12Z" />
    <circle cx="32.32" cy="14.17" r="1.82" />
    <circle cx="39.23" cy="14.17" r="1.82" />
    <circle cx="35.77" cy="17.63" r="1.82" />
    <circle cx="35.77" cy="10.72" r="1.82" />
    <polygon points="17.86 9.61 14.92 9.61 14.92 12.71 11.83 12.71 11.83 15.64 14.92 15.64 14.92 18.73 17.86 18.73 17.86 15.64 20.95 15.64 20.95 12.71 17.86 12.71 17.86 9.61" />
  </svg>
);

export default IconGames;
